/* Diamarte — interacciones propias (prefijo dm-) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function marcar(el) { if (el.dataset.dmListo) return false; el.dataset.dmListo = '1'; return true; }

  function initReveals() {
    var els = document.querySelectorAll('.dm-reveal:not(.dm-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('dm-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dm-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initColores() {
    document.querySelectorAll('[data-dm-colores]').forEach(function (root) {
      if (!marcar(root)) return;
      var botones = root.querySelectorAll('.dm-color');
      var imgs = root.querySelectorAll('.dm-colores__visor img');
      var enlace = root.querySelector('[data-dm-enlace]');
      botones.forEach(function (b, i) {
        b.addEventListener('click', function () {
          botones.forEach(function (x, j) { x.classList.toggle('dm-activa', i === j); x.setAttribute('aria-pressed', i === j); });
          imgs.forEach(function (x, j) { x.classList.toggle('dm-activa', i === j); });
          if (enlace && b.getAttribute('data-url')) enlace.href = b.getAttribute('data-url');
        });
      });
    });
  }

  function initGaleria() {
    document.querySelectorAll('[data-dm-galeria]').forEach(function (g) {
      if (!marcar(g)) return;
      var principal = g.querySelector('.dm-galeria__principal img');
      var minis = g.querySelectorAll('.dm-galeria__mini');
      function mostrar(m) {
        if (!m || !principal) return;
        minis.forEach(function (x) { x.classList.toggle('dm-activa', x === m); });
        principal.style.opacity = 0;
        setTimeout(function () {
          principal.src = m.getAttribute('data-src');
          principal.removeAttribute('srcset');
          principal.alt = m.getAttribute('data-alt') || '';
          principal.style.opacity = 1;
        }, 160);
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { mostrar(m); }); });
      g.dmMostrarMedia = function (mediaId) {
        var m = g.querySelector('.dm-galeria__mini[data-media="' + mediaId + '"]');
        if (m) { mostrar(m); m.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }
      };
    });
  }

  function formatearDinero(centimos, formato) {
    var valor = (centimos / 100).toFixed(2);
    return (formato || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, valor.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, valor)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(centimos / 100));
  }

  function initProducto() {
    document.querySelectorAll('[data-dm-producto]').forEach(function (root) {
      var form = root.querySelector('form[action*="/cart/add"]');
      if (!form || !marcar(root)) return;
      var datos = root.querySelector('[data-dm-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var formato = root.getAttribute('data-dm-formato');
      var inputId = form.querySelector('input[name="id"]');
      var boton = form.querySelector('[type="submit"]');
      var precio = root.querySelectorAll('[data-dm-precio]');
      var tachado = root.querySelector('[data-dm-tachado]');
      var ahorro = root.querySelector('[data-dm-ahorro]');
      var mensaje = root.querySelector('[data-dm-mensaje]');
      var galeria = root.querySelector('[data-dm-galeria]');
      var textoBoton = boton ? boton.getAttribute('data-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-agotado') : '';

      function actualizar() {
        var sel = [];
        root.querySelectorAll('.dm-opcion').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
          var etiqueta = fs.querySelector('legend span');
          if (etiqueta && c) etiqueta.textContent = c.getAttribute('data-label') || c.value;
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = textoAgotado; }
          return;
        }
        inputId.value = v.id;
        precio.forEach(function (p) { p.textContent = formatearDinero(v.price, formato); });
        var hay = v.compare_at_price && v.compare_at_price > v.price;
        if (tachado) { tachado.textContent = hay ? formatearDinero(v.compare_at_price, formato) : ''; tachado.hidden = !hay; }
        if (ahorro) { ahorro.hidden = !hay; if (hay) ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
        }
        if (v.media && galeria && galeria.dmMostrarMedia) galeria.dmMostrarMedia(v.media);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.querySelectorAll('.dm-opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });

      var cant = root.querySelector('.dm-cantidad input');
      root.querySelectorAll('[data-dm-cantidad]').forEach(function (b) {
        b.addEventListener('click', function () {
          cant.value = Math.max(1, (parseInt(cant.value, 10) || 1) + parseInt(b.getAttribute('data-dm-cantidad'), 10));
        });
      });

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (boton) boton.disabled = true;
        var fd = new FormData(form);
        fd.append('sections', 'cart-icon-bubble');
        var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(raiz + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status && res.status !== 200) throw new Error(res.description || res.message);
            var burbuja = document.getElementById('cart-icon-bubble');
            if (burbuja && res.sections && res.sections['cart-icon-bubble']) {
              var tmp = document.createElement('div');
              tmp.innerHTML = res.sections['cart-icon-bubble'];
              burbuja.innerHTML = (tmp.querySelector('.shopify-section') || tmp).innerHTML;
            }
            if (mensaje) mensaje.innerHTML = mensaje.getAttribute('data-ok');
          })
          .catch(function (err) { if (mensaje) mensaje.textContent = err.message || 'No se pudo añadir. Inténtalo de nuevo.'; })
          .finally(function () { if (boton) boton.disabled = false; });
      });

      var barra = document.querySelector('[data-dm-barra]');
      if (barra && boton) {
        var pendiente = false;
        var revisar = function () {
          pendiente = false;
          barra.classList.toggle('dm-mostrar', boton.getBoundingClientRect().bottom < 0);
        };
        window.addEventListener('scroll', function () {
          if (!pendiente) { pendiente = true; requestAnimationFrame(revisar); }
        }, { passive: true });
        revisar();
        var bBarra = barra.querySelector('button');
        if (bBarra) bBarra.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit(boton) : boton.click(); });
      }
    });
  }

  function initPestanas() {
    document.querySelectorAll('[data-dm-pestanas]').forEach(function (root) {
      if (!marcar(root)) return;
      var botones = root.querySelectorAll('[role="tab"]');
      var paneles = root.querySelectorAll('[role="tabpanel"]');
      botones.forEach(function (b, i) {
        b.addEventListener('click', function () {
          botones.forEach(function (x, j) { x.setAttribute('aria-selected', i === j); x.classList.toggle('dm-activa', i === j); });
          paneles.forEach(function (p, j) {
            p.hidden = i !== j;
            if (i === j) p.querySelectorAll('.dm-reveal').forEach(function (r) { r.classList.add('dm-visible'); });
          });
        });
      });
    });
  }

  function initCompraRapida() {
    document.querySelectorAll('[data-dm-rapida]').forEach(function (form) {
      if (!marcar(form)) return;
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var boton = form.querySelector('button');
        var texto = boton.innerHTML;
        boton.disabled = true;
        var fd = new FormData(form);
        fd.append('sections', 'cart-icon-bubble');
        var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(raiz + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status && res.status !== 200) throw new Error(res.description || res.message);
            var burbuja = document.getElementById('cart-icon-bubble');
            if (burbuja && res.sections && res.sections['cart-icon-bubble']) {
              var tmp = document.createElement('div');
              tmp.innerHTML = res.sections['cart-icon-bubble'];
              burbuja.innerHTML = (tmp.querySelector('.shopify-section') || tmp).innerHTML;
            }
            boton.innerHTML = form.getAttribute('data-ok') || '✓';
            setTimeout(function () { boton.innerHTML = texto; boton.disabled = false; }, 1800);
          })
          .catch(function () { boton.innerHTML = texto; boton.disabled = false; window.location.href = form.getAttribute('data-url'); });
      });
    });
  }

  function initTodo() {
    initPestanas();
    initCompraRapida(); initReveals(); initColores(); initGaleria(); initProducto(); }
  document.addEventListener('DOMContentLoaded', initTodo);
  document.addEventListener('shopify:section:load', initTodo);
})();
